import React from 'react'
import './form-button.scss'

/**
 * The props
 */
export interface FormButtonProps {
    /**
     * Callback when the button is clicked
     */
    onClick: () => void
}

/**
 * A button in a form.
 * 
 * @author Stan Hurks
 */
export default class FormButton extends React.Component<FormButtonProps> {

    public render = () => {
        return (
            <button
                className="form-button"
                onClick={() => {
                    this.props.onClick()
                }}>
                {
                    this.props.children
                }
            </button>
        )
    }
}